/* global axios */
import ApiClient from './ApiClient';

class OpportunitiesAPI extends ApiClient {
  constructor() {
    super('opportunities', { accountScoped: true });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  kanban(params = {}) {
    return axios.get(`${this.url}/kanban`, { params });
  }

  moveStage(id, { pipeline_stage_id, kanban_order }) {
    return axios.patch(`${this.url}/${id}/move_stage`, {
      pipeline_stage_id,
      kanban_order,
    });
  }

  getActivities(opportunityId) {
    return axios.get(`${this.url}/${opportunityId}/activities`);
  }

  createActivity(opportunityId, data) {
    return axios.post(`${this.url}/${opportunityId}/activities`, {
      opportunity_activity: data,
    });
  }

  updateActivity(opportunityId, activityId, data) {
    return axios.patch(
      `${this.url}/${opportunityId}/activities/${activityId}`,
      { opportunity_activity: data }
    );
  }

  deleteActivity(opportunityId, activityId) {
    return axios.delete(
      `${this.url}/${opportunityId}/activities/${activityId}`
    );
  }

  registerFollowup(id, { message } = {}) {
    return axios.post(`${this.url}/${id}/register_followup`, { message });
  }

  exportData(pipelineIds = null) {
    return axios.post(`${this.url}/export_data`, {
      pipeline_ids: pipelineIds,
    });
  }

  bulkCreateFromContacts({ pipeline_id, pipeline_stage_id, contact_ids }) {
    return axios.post(`${this.url}/bulk_create_from_contacts`, {
      pipeline_id,
      pipeline_stage_id,
      contact_ids,
    });
  }

  archive(id) {
    return axios.patch(`${this.url}/${id}/archive`);
  }

  unarchive(id) {
    return axios.patch(`${this.url}/${id}/unarchive`);
  }
}

export default new OpportunitiesAPI();
